/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useConfig } from '@salesforce/storefront-next-runtime/config';
import { getTrueVaultPrivacyLinks, type TrueVaultPrivacyLinks } from '@/analytics/truevault-consent-config';

/**
 * RGBARRY-CUSTOMIZATION (DRAFT, W-23789028 consent rework): reads app config and returns the validated
 * TrueVault visible-notice link set, or `null` when TrueVault is not fully configured (empty/invalid
 * scriptUrl or privacyCenterUrl). Callers fall back to the pre-TrueVault internal links when null.
 * Lives in its own module so the notice components file can stay component-only (fast-refresh rule).
 */
export function useTrueVaultPrivacyLinks(): TrueVaultPrivacyLinks | null {
    const config = useConfig();
    return getTrueVaultPrivacyLinks(config?.engagement?.consent?.truevault);
}
